import styled from 'styled-components'

const StyledReceiptView = styled.div`
  h1 {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
      height: 42px;
      color: ${({ theme }) => theme.colors.green[300]};
      margin-right: 1rem;

      path {
        stroke-width: 1.5px;
      }
    }
  }

  h2 {
    text-align: center;
    font-weight: 500;
    margin: 10px 0 20px 0;
    color: ${({ theme }) => theme.colors.gray[700]};
    font-size: 29px;
  }

  p {
    font-weight: 500;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray[400]};
  }

  .cart-area {
    margin: 60px 0;
  }
`

export default StyledReceiptView
